import axios from 'axios';
import { HOST } from 'variables';

export default axios.create({
  baseURL: HOST
});

export const axiosPrivate = axios.create({
  baseURL: HOST,
  headers: { 'Content-Type': 'application/json' }
  //   withCredentials: true,
});
